import React from "react";
import {LoaderAnimate} from '../LoaderAnimate'

const Loader = ({ primaryText, secondaryText }) => {
  return (
    <div className="">
      <LoaderAnimate/>

      <div className="text-center text-primary mt-5">
        <span className="text-3xl font-bold mx-auto block">{primaryText}</span>
        <br />
        <span className="text-3xl font-normal">{secondaryText}</span>
      </div>
    </div>
  );
};
Loader.defaultProps = {
  primaryText: "¡Un momento por favor!",
  secondaryText: "",
};

export default Loader;
